namespace AgerLMS.LMS {
    export interface ProductRow {
        ProductId?: number;
        SellerId?: number;
        ProductType?: ProductTypes;
        ProductTitle?: string;
        Tax?: number;
        Commission?: number;
        SeoMetaDescription?: string;
        ProductSummary?: string;
        ProductDescription?: string;
        CategoryId?: number;
        EnableOrdering?: boolean;
        Price?: number;
        DeliveryFee?: number;
        DeliveryEstimatedTime?: number;
        UnlimitedInventory?: boolean;
        Inventory?: number;
        InventoryWarning?: number;
        Thumbnail?: string;
        CoverImage?: string;
        DemoVideo?: string;
        Specifications?: string;
        DisplayOrder?: number;
        Seo?: string;
        SalesStatus?: SalesStatus;
        IncludesCargoPrice?: boolean;
        CategoryCategoryName?: string;
        InsertUserId?: number;
        InsertDate?: string;
        UpdateUserId?: number;
        UpdateDate?: string;
        IsActive?: number;
        InsertUserDisplayName?: string;
    }

    export namespace ProductRow {
        export const idProperty = 'ProductId';
        export const isActiveProperty = 'IsActive';
        export const nameProperty = 'ProductTitle';
        export const localTextPrefix = 'LMS.Product';
        export const deletePermission = 'LMS:Product:Modify';
        export const insertPermission = 'LMS:Product:Modify';
        export const readPermission = 'LMS:Product:Read';
        export const updatePermission = 'LMS:Product:Modify';

        export declare const enum Fields {
            ProductId = "ProductId",
            SellerId = "SellerId",
            ProductType = "ProductType",
            ProductTitle = "ProductTitle",
            Tax = "Tax",
            Commission = "Commission",
            SeoMetaDescription = "SeoMetaDescription",
            ProductSummary = "ProductSummary",
            ProductDescription = "ProductDescription",
            CategoryId = "CategoryId",
            EnableOrdering = "EnableOrdering",
            Price = "Price",
            DeliveryFee = "DeliveryFee",
            DeliveryEstimatedTime = "DeliveryEstimatedTime",
            UnlimitedInventory = "UnlimitedInventory",
            Inventory = "Inventory",
            InventoryWarning = "InventoryWarning",
            Thumbnail = "Thumbnail",
            CoverImage = "CoverImage",
            DemoVideo = "DemoVideo",
            Specifications = "Specifications",
            DisplayOrder = "DisplayOrder",
            Seo = "Seo",
            SalesStatus = "SalesStatus",
            IncludesCargoPrice = "IncludesCargoPrice",
            CategoryCategoryName = "CategoryCategoryName",
            InsertUserId = "InsertUserId",
            InsertDate = "InsertDate",
            UpdateUserId = "UpdateUserId",
            UpdateDate = "UpdateDate",
            IsActive = "IsActive",
            InsertUserDisplayName = "InsertUserDisplayName"
        }
    }
}
